import React, { type RefObject } from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import VideoSkipBackwardFifteenIcon from '@atlaskit/icon/core/video-skip-backward-fifteen';

import { AudioControlIconButton } from './sub-components/AudioControlButton';

const SKIP_SECONDS = 15;
const START_SECONDS = 0;

const i18n = defineMessages({
	skipBackButtonLabel: {
		id: 'audio.miniplayer-controls.skip-back-label',
		defaultMessage: 'Skip Back',
		description:
			'The label is used as a tooltip and for accessibility for the icon button which will skip the currently active audio back "x" seconds',
	},
});

export type SkipBackButtonProps = {
	audioRef: RefObject<HTMLAudioElement>;
	isDisabled?: boolean;
	onClick?: () => void;
};

export const SkipBackButton = ({
	audioRef,
	onClick = () => {},
	isDisabled = false,
}: SkipBackButtonProps): React.ReactNode => {
	const intl = useIntl();

	const handleSkipBack = () => {
		const audio = audioRef.current;
		if (audio) {
			if (audio.currentTime <= SKIP_SECONDS) {
				audio.currentTime = START_SECONDS;
			} else {
				audio.currentTime -= SKIP_SECONDS;
			}
		}
	};

	const handleClick = () => {
		handleSkipBack();
		onClick?.();
	};

	return (
		<AudioControlIconButton
			Icon={VideoSkipBackwardFifteenIcon}
			label={intl.formatMessage(i18n.skipBackButtonLabel)}
			tooltip={intl.formatMessage(i18n.skipBackButtonLabel)}
			onClick={handleClick}
			isDisabled={isDisabled}
			testId="miniplayer-skip-back"
		/>
	);
};
